export default __webpack_public_path__ + "static/media/Key.e05c8732.svg";